// src/store/slices/authSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
// import { cleanupBalanceSubscription } from './balanceSlice';

interface AuthState {
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { setAuthenticated } = authSlice.actions;
export default authSlice.reducer;